module.exports = (__parcel__import__("aUPqk")).then(() => parcelRequire('kRw5D'));